import { SharedModule } from './../shared/shared.module';
import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ForgotPasswordComponent } from "./pages/forgot-password/forgot-password.component";
import { LoginComponent } from "./pages/login/login.component";
import { RegisterComponent } from "./pages/register/register.component";
import { AuthComponent } from "./pages/auth.component";
import { AuthNoticeComponent } from './pages/auth-notic/auth-notic.component';
import { AuthRoutingModule } from "./pages/auth-routing.module";
import {
  MatSelectModule,
  MatButtonModule,
  MatInputModule,
  MatFormFieldModule,
  MatCheckboxModule,
  MatDatepickerModule,
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  MatProgressBarModule,
  MatTabsModule,
  MatTooltipModule,
  MatAutocompleteModule,
  MatListModule,
  MatSliderModule,
  MatCardModule,
  MatNativeDateModule,
  MatIconModule,
  MatSlideToggleModule,
  MatMenuModule,
  MatSidenavModule,
  MatProgressSpinnerModule,
  MatSnackBarModule,
  MatTableModule,
  MatGridListModule,
  MatToolbarModule,
  MatBottomSheetModule,
  MatExpansionModule,
  MatDividerModule,
  MatSortModule,
  MatStepperModule,
  MatChipsModule,
  MatPaginatorModule,
  MatDialogModule,
  MatRippleModule,
  MatRadioModule,
  MatTreeModule,
  MatButtonToggleModule
} from "@angular/material";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InterceptService } from "./../../../core/_base/crud";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthService, AuthGuard, authReducer, AuthEffects } from './../../../core/auth';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { InlineSVGModule } from 'ng-inline-svg';
import {
  MaterialPersianDateAdapter,
  PERSIAN_DATE_FORMATS
} from "../shared/material.persian-date.adapter";
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { LoginNComponent } from './pages/newAuthDesign/login-n/login-n.component';
import { CodeInputComponent } from './pages/newAuthDesign/code-input/code-input.component';
import { LoginPassComponent } from './pages/newAuthDesign/login-n/login-pass/login-pass.component';
import { ResetPasswordComponent } from './pages/newAuthDesign/login-n/reset-password/reset-password.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AuthNComponent } from './pages/auth-n.component'; 
import { PartialsModule } from '../../partials/partials.module';
import { CoreModule } from '../../../core/core.module';


@NgModule({

  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    LoadingBarModule,
    NgxDaterangepickerMd,
    InlineSVGModule,
    AuthRoutingModule,
    TranslateModule.forChild(),
    StoreModule.forFeature('auth', authReducer),
    EffectsModule.forFeature([AuthEffects]),
    MatProgressBarModule,
    MatTabsModule,
    MatButtonModule,
    MatTooltipModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatListModule,
    MatSliderModule,
    MatCardModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatMenuModule,
    MatTabsModule,
    MatTooltipModule,
    MatSidenavModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTableModule,
    MatGridListModule,
    MatToolbarModule,
    MatBottomSheetModule,
    MatExpansionModule,
    MatDividerModule,
    MatSortModule,
    MatStepperModule,
    MatChipsModule,
    MatPaginatorModule,
    MatDialogModule,
    MatRippleModule,
    MatRadioModule,
    MatTreeModule,
    MatButtonToggleModule,
    NgxCaptchaModule,
    PartialsModule,
    CoreModule,
    SharedModule
  ],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true
    },
    {
      provide: DateAdapter,
      useClass: MaterialPersianDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: PERSIAN_DATE_FORMATS },
  ],
  exports: [AuthComponent,AuthNComponent],
  declarations: [
    AuthNoticeComponent,
    ForgotPasswordComponent,
    LoginComponent,
    RegisterComponent,
    AuthComponent,
    LoginNComponent,
    CodeInputComponent,
    LoginPassComponent,
    ResetPasswordComponent,
    AuthNComponent
  ]
})
export class AuthModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        AuthService,
        AuthGuard
      ]
    };
  }
}
